import moment from 'moment';

import {
  createReducer,
  createRequestReducer
} from 'utils';
import { GET_CHART_DATA } from './constants';

// import mock from './mock';

const initialState = {
  items: [],
  isFetching: false,
  fetchingErrors: null
};

function processItems(measures) {
  let minMomentDate;
  let maxMomentDate;

  const points = measures.map(el => {
    const momentDate = moment(el.dateMeasured);

    if (!minMomentDate) {
      minMomentDate = momentDate;
    } else {
      minMomentDate = moment.min(minMomentDate, momentDate);
    }

    if (!maxMomentDate) {
      maxMomentDate = momentDate;
    } else {
      maxMomentDate = moment.max(minMomentDate, momentDate);
    }

    return {
      date: momentDate.format('DD MMMM YYYY'),
      uscProfit: parseFloat(el.uscProfit),
      reference: parseFloat(el.reference),
      depositProfit: parseFloat(el.depositProfit)
    };
  });

  const items = [];

  while (minMomentDate.diff(maxMomentDate) <= 0) {
    const dateDisplay = minMomentDate.format('DD MMMM YYYY');
    const point = points.find(el => el.date === dateDisplay) || null;

    items.push({
      point,
      dateDisplay,
      year: minMomentDate.year()
    });

    minMomentDate.add(1, 'day');
  }

  return items;
}

export default createReducer(initialState, {
  [GET_CHART_DATA]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        const result = action.request.response;

        return Object.assign(state, {
          items: processItems(result),
          isFetching: false,
          fetchingErrors: null
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/Chart/reducer.js